import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, bindActionCreators } from 'redux';
import { connect, Provider } from 'react-redux';
import { I18nextProvider, withTranslation } from 'react-i18next';
import i18n from '../i18n';

import GanttChartComp from './gantt';
import ImgIconComp from '../components/imgcomp';
import { MemberCapacity } from './MemberCapacity';

// start of workload bandwidth functionality
// load page and initialize components
const workloadBandwidthPageLoadComponent = function (data) {
  console.log('workloadBandwidthPageLoadComponent');

  const workLoadMapsStateToProps = state => ({
    workload: state,
  });
  const actions = {
    WorkLoadFullLoad, WorkloadStatusFilter, WorkloadPriorityFilter, WorkloadUserFilter, WorkloadWsFilter, WorkloadObjectiveFilter,
  };
  const workloadMapsDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  });

  const workloadStore = createStore(WorkloadBandwidth, data);
  const WorkloadAppComp = connect(
    workLoadMapsStateToProps,
    workloadMapsDispatchToProps,
  )(WorkloadBandwidthComp);
  ReactDOM.render(
    <Provider store={workloadStore}>
      <Suspense fallback="loading...">
        <I18nextProvider i18n={i18n}>
          <WorkloadAppComp />
        </I18nextProvider>
      </Suspense>,
    </Provider>,
    document.getElementById('workloadBandwidthOuterTableWrapper'),
  );
};

window.workloadBandwidthPageLoadComponent = workloadBandwidthPageLoadComponent;

// define constants
const WORKLOAD_FULL_LOAD = 'WORKLOAD_FULL_LOAD';
const WORKLOAD_STATUS_FILTER = 'WORKLOAD_STATUS_FILTER';
const WORKLOAD_PRIORITY_FILTER = 'WORKLOAD_PRIORITY_FILTER';
const WORKLOAD_USER_FILTER = 'WORKLOAD_USER_FILTER';
const WORKLOAD_WS_FILTER = 'WORKLOAD_WS_FILTER';
const WORKLOAD_OBJECTIVE_FILTER = 'WORKLOAD_OBJECTIVE_FILTER';

// define action types
const WorkLoadFullLoad = item => ({ type: WORKLOAD_FULL_LOAD, value: item });
const WorkloadStatusFilter = (checked, item, value) => ({
  type: WORKLOAD_STATUS_FILTER, checked, item, value,
});
const WorkloadPriorityFilter = (checked, item, value) => ({
  type: WORKLOAD_PRIORITY_FILTER, checked, item, value,
});
const WorkloadUserFilter = item => ({ type: WORKLOAD_USER_FILTER, value: item });
const WorkloadWsFilter = item => ({ type: WORKLOAD_WS_FILTER, value: item });
const WorkloadObjectiveFilter = item => ({ type: WORKLOAD_OBJECTIVE_FILTER, value: item });


// define reducers
const WorkloadBandwidth = (state = {}, action) => {
  const initState = state;
  console.log(`action type --> ${action.type}`);
  switch (action.type) {
    case WORKLOAD_FULL_LOAD:
      // console.log(action.value);
      const { viewMode } = initState.workloadDetails;
      state = action.value;
      state.workloadDetails.viewMode = viewMode;
      // state = {...state, initState};
      break;
    case WORKLOAD_STATUS_FILTER:
      // console.log(action.value);
      // console.log(initState);
      if (action.item == 'doing') {
        initState.workloadDetails.status.doing = action.checked;
      } else if (action.item == 'next') {
        initState.workloadDetails.status.next = action.checked;
      } else if (action.item == 'pause') {
        initState.workloadDetails.status.pause = action.checked;
      } else if (action.item == 'done') {
        initState.workloadDetails.status.done = action.checked;
      }
      state = { ...state, initState };
      break;
    case WORKLOAD_PRIORITY_FILTER:
      // console.log(action.value);
      // console.log(initState);
      if (action.item == 'low') {
        initState.workloadDetails.priority.low = action.checked;
      } else if (action.item == 'medium') {
        initState.workloadDetails.priority.medium = action.checked;
      } else if (action.item == 'high') {
        initState.workloadDetails.priority.high = action.checked;
      }
      state = { ...state, initState };
      break;
    case WORKLOAD_USER_FILTER:
      // console.log(action.value);
      initState.workloadDetails.filter_people.selUser = action.value;
      state = { ...state, initState };
      break;

    case WORKLOAD_WS_FILTER:
      console.log(action.value);
      initState.workloadDetails.filter_ws = action.value;
      state = { ...state, initState };
      break;
    case WORKLOAD_OBJECTIVE_FILTER:
      // console.log(action.value);
      initState.workloadDetails.filter_objective = action.value;
      state = { ...state, initState };
    default:
      state = { ...state, initState };
      break;
  }
  // console.log(state);
  return state;
};

class WorkloadBandwidthComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      workloadDetails: this.props.workload.workloadDetails || {},
    };
    this.triggerEvents = this.triggerEvents.bind(this);
  }

  componentDidMount() {
    this.mountId = document.getElementById('workloadChartData');
  }

  triggerEvents(event, method = null, args) {
    if (this[event]) {
      if (typeof method !== 'undefined') {
        this[event][method].apply(null, args);
      } else {
        this[event].apply(null, args);
      }
    }
  }

  render() {
    console.log('rerender WorkloadBandwidthComp...');
    return (
      <div>
        <div className="workloadHeaderSection">
                	Workload & Bandwidth
        </div>
        <div className="workloadFilterSection">
          <WorkloadFiltersComp {...this.props} />
        </div>

        <div id="workloadChartData">
          <WorkloadChartDataComp {...this.props} />
        </div>
      </div>
    );
  }
}

class WorkloadChartDataComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _timeline: this.props.workload.workloadDetails || {},
      _user_workload: {},
      _user_ws_workload: {},
      userId: null,
      userName: null,
      showMemberCapacityPopup: false,
    };
    this.triggerEvents = this.triggerEvents.bind(this);
    this.handleAfterGridRender = this.handleAfterGridRender.bind(this);
    this.workloadFilter = this.workloadFilter.bind(this);
    this.constructWSStr = this.constructWSStr.bind(this);
    this.calculateWeeks = this.calculateWeeks.bind(this);
    this.getBusinessDatesCount = this.getBusinessDatesCount.bind(this);
    this.hideGanttPopup = this.hideGanttPopup.bind(this);
    this.handleAiEvent = this.handleAiEvent.bind(this);
    this.handleShowDetaials = this.handleShowDetaials.bind(this);
    this.handleWeekTextClick = this.handleWeekTextClick.bind(this);
    this.handleMemberCapacityPopupClose = this.handleMemberCapacityPopupClose.bind(this);
  }

  triggerEvents(event, method = null, args) {
    if (this[event]) {
      if (typeof method !== 'undefined') {
        this[event][method].apply(null, args);
      } else {
        this[event].apply(null, args);
      }
    }
  }

  handleAfterGridRender(mode) {
    const date = new Date();
    const seconds = date.getTime();
    // console.log("after time-->"+seconds);

    let chartWidth = $(window).width() - 107;
    const keepopen = $('#leftmenu_navigation').find('.leftmenu-wrapper').attr('data-keepopen');
    if (keepopen === 'true' || typeof keepopen === 'undefined') {
      chartWidth -= 263;
    }
    if (keepopen === 'false') {
      chartWidth -= 10;
    }
    chartWidth -= 201;
    $('.gantt-chart-wrapper').width(chartWidth);
    this.props.workload.workloadDetails.viewMode = mode;
    // console.log(mode);
  }

  workloadFilter(tasks) {
    const chartData = this.props.workload.workloadDetails;
    	const doingStatus 	= chartData.status.doing;
    	const nextStatus 		= chartData.status.next;
    	const pauseStatus 	= chartData.status.pause;
    	const doneStatus 		= chartData.status.done;
    	const lowPriority		= chartData.priority.low;
    	const mediumPriority	= chartData.priority.medium;
    	const highPriority 	= chartData.priority.high;
    const userFilter = chartData.filter_people.selUser;
    const wsFilter = chartData.filter_ws;
    const ObjectiveFilter = chartData.filter_objective;
    const popleSelectAll = chartData.filter_sele_all.people || false;
    const wsSelectAll = chartData.filter_sele_all.ws || false;
    const objSelectAll = chartData.filter_sele_all.objective || false;
    // console.log(userFilter);
    // console.log(wsFilter);
    // console.log(ObjectiveFilter);
    // console.log(popleSelectAll);
    // console.log(wsSelectAll);
    // console.log(objSelectAll);

    	let _tasks = tasks.map((tasks1) => {
      let _k = tasks1.data.filter((item1) => {
        if (doingStatus && item1.state == '1') {
               		return true;
        } if (nextStatus && item1.state == '2') {
               		return true;
        } if (pauseStatus && item1.state == '4') {
               		return true;
        } if (doneStatus && item1.state == '0') {
               		return true;
        } if (!doingStatus && !nextStatus && !pauseStatus && !doneStatus) {
               		return true;
        }
               		return false;
      });
      _k = _k.filter((item1) => {
        if (lowPriority && item1.priority == '3') {
               		return true;
        } if (mediumPriority && item1.priority == '2') {
               		return true;
        } if (highPriority && item1.priority == '1') {
               		return true;
        } if (!lowPriority && !mediumPriority && !highPriority) {
               		return true;
        }
               		return false;
      });
      tasks1.data = _k.filter((item1) => {
        if ($.inArray(item1.owner, userFilter) > -1 || $.inArray(item1.wsId, wsFilter) > -1 || $.inArray(item1.wsId, ObjectiveFilter) > -1) {
          return true;
        }
      });
      /* tasks1.data = _k.filter(item1 => {
                if($.inArray(item1.wsId, wsFilter) > -1){
                    return true;
                }
            }); */

      let weeks = 0;
      let _user_workload = {}; let
        _user_ws_workload = {};
      if (tasks1.data.length) {
            	/* for(var i=0;i<tasks1.data.length;i++) {
            		weeks = weeks + tasks1.data[i].diff_days;
            	}
            	if(weeks>0) {
            		weeks = weeks/5;
            		weeks = weeks.toFixed(1);
            	} */
        weeks = this.calculateWeeks(tasks1.data, tasks1.timeoff);
        _user_workload = this.state._user_workload;
        _user_ws_workload = this.state._user_ws_workload;
      }
      tasks1.weeks = `${weeks}w`;
      tasks1.userWorkload = _user_workload;
      tasks1.userWsWorkload = _user_ws_workload;
      return tasks1;
    });
    if (popleSelectAll == false || wsSelectAll == false || objSelectAll == false) {
      _tasks = tasks.filter((tasks1) => {
        if (tasks1.data.length) {
          return true;
        }
        return false;
      });
    }
    return _tasks;
  }

  constructWSStr(wsId, state, priority) {
    let wsStr;
    if (state == '1') {
      wsStr = `${wsId}_P_${priority}`;
    } else {
      wsStr = `${wsId}_S_${state}`;
    }
    return wsStr.toString();
  }

  calculateWeeks(_tasks_data, _timeoff) {
    let _week = 0; let _days = 0; let _inWeek; const _wsId = []; const
      _day = 0;
    let _tasks;
    let priority_low = 0; let priority_medium = 0; let priority_high = 0; let doing_state = 0; let next_state = 0; let pause_state = 0; let done_state = 0; let
      user_workoad_list = {};
    if (_tasks_data.length) {
      let _m = [];
      let i = 0;
      const wsData = {}; let
        wsStr;
      // console.log(_tasks_data.length);
      _tasks = _tasks_data.map((_tasks1) => {
        // console.log("i->"+i);
        // console.log(_tasks1.start+" - "+_tasks1.end);
        if (_m.length) {
          let checked = 0;
          // console.log("start" + checked);
          // console.log(_tasks1.start);
          // console.log(_tasks1.end);
          // console.log(_m.length);
          for (let j = 0; j < _m.length; j++) {
            // console.log(_tasks1.start);
            // console.log(_m[j].start);
            // console.log("----");
            // console.log(_tasks1.end);
            // console.log(_m[j].end);
            // console.log("----");
            if (_tasks1.start <= _m[j].end && _m[j].start <= _tasks1.end) {
              checked = 1;
              _m[j].start = Math.min(_m[j].start, _tasks1.start);
              _m[j].end = Math.max(_m[j].end, _tasks1.end);
              if (_tasks1.end == _m[j].end) {
                _m[j].id = _tasks1.id;
                _m[j].state = _tasks1.state;
                _m[j].priority = _tasks1.priority;
                _m[j].wsId = _tasks1.wsId;
                _m[j].tag_name = _tasks1.tag_name;
              }
            }
          }
          // console.log("end" + checked);
          if (checked == 0) {
            _m[i] = {
              id: _tasks1.id, start: _tasks1.start, end: _tasks1.end, state: _tasks1.state, priority: _tasks1.priority, wsId: _tasks1.wsId, tag_name: _tasks1.tag_name,
            };
            i += 1;
          }
        } else {
          _m[i] = {
            id: _tasks1.id, start: _tasks1.start, end: _tasks1.end, state: _tasks1.state, priority: _tasks1.priority, wsId: _tasks1.wsId, tag_name: _tasks1.tag_name,
          };
          i += 1;
        }

        wsStr = this.constructWSStr(_tasks1.wsId, _tasks1.state, _tasks1.priority);
        if (typeof _wsId[wsStr] !== 'undefined') {
          _wsId[wsStr].push(_tasks1);
        } else {
          _wsId[wsStr] = [];
          _wsId[wsStr].push(_tasks1);
        }
        return _tasks1;
      });
      const _tem = [];
      const temp = [];
      i = 0;
      if (_m.length) {
        // console.log(_m);
        _m.map((_tasks1) => {
          // console.log(_tasks1.start+" - "+_tasks1.end);
          if (temp.length) {
            let checked = 0; let
              j = 0;
            // console.log(temp);
            for (j = 0; j < temp.length; j++) {
              if (_tasks1.start <= temp[j].end && temp[j].start <= _tasks1.end) {
                checked = 1;
                temp[j].start = Math.min(temp[j].start, _tasks1.start);
                temp[j].end = Math.max(temp[j].end, _tasks1.end);
                if (_tasks1.end == temp[j].end) {
                  temp[j].id = _tasks1.id;
                  temp[j].state = _tasks1.state;
                  temp[j].priority = _tasks1.priority;
                  temp[j].wsId = _tasks1.wsId;
                  temp[j].tag_name = _tasks1.tag_name;
                }
              }
            }
            if (checked == 0) {
              temp[i] = _tasks1;
              i += 1;
            }
          } else {
            temp[i] = _tasks1;
            i += 1;
          }
        });
        _m = temp;
        // console.log(_m);
        for (let k = 0; k < _m.length; k++) {
          // console.log(_tem)
          if ($.inArray(`${_m[k].start}_${_m[k].end}`, _tem) > -1) {
            continue;
          }
          // console.log("startDate -> "+_m[k].start);
          // console.log("endDate  -> "+_m[k].end);
          _tem.push(`${_m[k].start}_${_m[k].end}`);
          _m[k].days = this.getBusinessDatesCount(new Date(_m[k].start * 1000), new Date(_m[k].end * 1000), _timeoff);
          // console.log("diff days -> "+_m[k].days);
          _inWeek = (_m[k].days / 5);
          /* if(_wsId.length) {
                        _wsId[_m[k].wsId] = this.constructWSData(_m[k],_wsId[_m[k].wsId],_inWeek);
                    } else {
                        _wsId[_m[k].wsId] = this.constructWSData(_m[k],undefined,_inWeek);
                    } */
          _m[k].weeks = _inWeek.toFixed(1);
          if (_m[k].state == '1') {
            doing_state += _inWeek;
            if (_m[k].priority == '3') {
              priority_low += _inWeek;
            } else if (_m[k].priority == '2') {
              priority_medium += _inWeek;
            } else if (_m[k].priority == '1') {
              priority_high += _inWeek;
            }
          } else if (_m[k].state == '0') {
            done_state += _inWeek;
          } else if (_m[k].state == '2') {
            next_state += _inWeek;
          } else if (_m[k].state == '4') {
            pause_state += _inWeek;
          }
          _days += _m[k].days;
        }
      }

      // console.log(_days);
      if (_days > 0) {
        _week = (_days / 5).toFixed(1);
      }
      // console.log(_wsId);
      user_workoad_list = {
        done_state,
        next_state,
        pause_state,
        doing_state: {
          count: doing_state, high: priority_high, medium: priority_medium, low: priority_low,
        },
      };
      this.state._user_workload = user_workoad_list;
      this.state._user_ws_workload = _wsId;
      // console.log(_wsId);
      // console.log(this.state._user_ws_workload);
    } else {
      this.state._user_workload = {};
      this.state._user_ws_workload = _wsId;
    }
    return _week;
  }

  getBusinessDatesCount(startDate, endDate, _timeoff) {
    const timeoff = _timeoff || [];
    // console.log(timeoff);
    let count = 0;
    const curDate = startDate;

    while (curDate <= endDate) {
      const dayOfWeek = curDate.getDay();
      // console.log(timeoff.indexOf(+curDate));
      if (!((dayOfWeek == 6) || (dayOfWeek == 0) || timeoff.indexOf(+curDate) > -1)) {
        count++;
      }
      curDate.setDate(curDate.getDate() + 1);
    }
    return count;
  }

  hideGanttPopup() {
    $('#gantt-popup').hide();
    $('.memberAiPopupArrow').hide();
    $('#workloadChartData .left').first().css({ 'margin-bottom': '0px' });
    if (document.getElementById('gantt-popup')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('gantt-popup'));
    }
  }

  handleAiEvent(item) {
    const aiId = item.id;
    const urlVal = `${wbConfig.baseUrl}/activity/aI?id=${aiId}`;
    setTimeout(() => openFullPopUp(aiFullViewPopUp, urlVal), 500);
  }

  handleShowDetaials(task, bar, event, position) {
    const self = this;
    console.log('handleShowDetaials');
    // console.log(task);
    self.hideGanttPopup();
    if (typeof task.wsId !== 'undefined') {
      const tagId = task.wsId;
      const boardDet = this.state.boardDetails;

      // open mini popup
      const dim = event.target.getBoundingClientRect();
      let dimLeft = dim.left;
      // console.log(dim.left);
      // var eventX = event.clientX - dim.left;
      // var eventY = event.clientY - dim.top;
      // console.log(position);
      const { x, y } = position;
      // console.log(x);
      // console.log(y);
      let caly = y + 112;
      let calx = event.pageX - 80;
      const keepopen = $('.workstreamMainWs .workstreamLeftCol').attr('keepopen');
      let width = $(window).width() - 65 - 400;
      if (keepopen === 'true' || typeof keepopen === 'undefined') {
        calx -= 260;
        width -= 250;
        dimLeft -= 250;
        caly += 6;
      } else {
        /* commenting as its depricated in latest versions of jquery
                if ($.browser.mozilla) {
                    caly = caly-11;
                } */
      }
      calx = calx < 0 ? 30 : calx;

      if (calx > width) {
        calx = width - 5;
      }
      $('#gantt-popup').show().css({ left: calx, top: caly });
      if (caly > 400) {
        $('#workloadChartData .left').first().css({ 'margin-bottom': '255px' });
      }
      if (task.overlapping_items.length) {
        if (dimLeft - 67 > 220) {
          $('.memberAiPopupArrow').show().css({ left: dimLeft - 67, top: caly - 27 });
        }
      }

      // console.log(task);
      ReactDOM.render(<WorkLoadAIItemsComp items={task} handlers={this.handleAiEvent} tagId="" />, document.getElementById('gantt-popup'));
    }
  }

  handleWeekTextClick(id) {
    const userId = $(`#${id}`).attr('data-user-id');
    const userName = $(`#${id}`).attr('data-user-name');
    this.setState({
      userId,
      userName,
      showMemberCapacityPopup: true,
    });
  }

  handleMemberCapacityPopupClose() {
    this.setState({
      userId: null,
      userName: null,
      showMemberCapacityPopup: false,
    });
  }

  render() {
    console.log('workloadChartDataComp');
    const _timeline1 = this.props.workload.workloadDetails;
    // console.log(_timeline1);
    const is_manager = false;
    const is_co_manager = false;
    const is_team_admin = false;
    const user = {};
    const events = {
      on_show_details: this.handleShowDetaials,
      on_after_grid_render: this.handleAfterGridRender,
      on_task_list_week_name: this.handleWeekTextClick,
    };
    let sortingId = 'asc';
    if ($('#gantt-sorting').length) {
      const sortingView = $('#gantt-sorting').attr('data-value');
      if (sortingView !== 'undefined') {
        sortingId = sortingView;
      }
    }
    const config = {
      svg_class: 'wb-board-timeline-svg',
      task_list_width: 1,
      bar: {
        height: 10,
        corner_radius: 2.5,
        class: 'wsBoardAiFullDet',
      },
      padding: 30,
      header_height: 40,
      current_user_id: user.id || null,
      is_manager: is_manager || false,
      is_co_manager: is_co_manager || false,
      is_team_admin: is_team_admin || false,
      render_task_list: 'ws-task-name-wrapper',
      gantt_start: _timeline1.startDateEpoch || null,
      gantt_end: _timeline1.endDateEpoch || null,
      view_mode: _timeline1.viewMode || 'Week',
      overlap_label: true,
      shadecolor: '#FFF',
      renderpage: 'workload',
      sorting: {
        enabled: true,
        id: sortingId,
      },

    };
    // console.log(_timeline1);
    _timeline1.filterUserList = [];
    const timeline1 = JSON.parse(JSON.stringify(_timeline1));
    let tasks = timeline1.timelines || [];
       	tasks = this.workloadFilter(tasks);
    this.props.workload.workloadDetails.filterUserList = tasks;
    const { showMemberCapacityPopup, userId, userName } = this.state;

    return (
      <>
        {showMemberCapacityPopup &&
        <MemberCapacity
          {...this.props}
          userId={userId}
          userName={userName}
          onClose={() => this.handleMemberCapacityPopupClose()}
        />
        }
        <div className="left">
          <div id="ws-task-name-wrapper" className="left worload-task-name-wrapper" />
          <GanttChartComp config={config} key={Math.random()} tasks={tasks} class="ws-timeline-wrapper left " events={events} />
        </div>
      </>
    );
  }
}

class WorkloadFiltersComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMemberCapacityPopup: false,
    };
    this.initDatePicker = this.initDatePicker.bind(this);
    this.initializeDueDate = this.initializeDueDate.bind(this);
    this.initializeStartDate = this.initializeStartDate.bind(this);
    this.startDateClick = this.startDateClick.bind(this);
    this.dueDateClick = this.dueDateClick.bind(this);
    this.saveStartDate = this.saveStartDate.bind(this);
    this.saveEndDate = this.saveEndDate.bind(this);
    this.loadFullComponent = this.loadFullComponent.bind(this);
    this.triggerLoadFullComponent = this.triggerLoadFullComponent.bind(this);
    this.satusFilterClick = this.satusFilterClick.bind(this);
    this.saveFilterOption = this.saveFilterOption.bind(this);
    this.priorityFilterClick = this.priorityFilterClick.bind(this);
    this.member_capacity = this.member_capacity.bind(this);
  }

  componentDidMount() {
    this.initializeDueDate();
    this.initializeStartDate();
  }

  componentWillUnmount() {
  }

  componentWillReceiveProps() {
    // console.log("componentWillReceiveProps");
  }

  initDatePicker(obj, callback, current_date, maxOrMin, maxMinDate) {
    this.datepicker = $(obj);
    const _this = this;
    $(this.datepicker).datepicker({
      showAnim: 'slide',
      dateFormat: 'M d,yy',
      onChangeMonthYear(year, month, inst) {
        const buttonPane = $(inst.input).datepicker('widget');
        $(buttonPane).find('button.newStyleForDatePicker').remove();
      },
      beforeShow(input, inst) {
        setTimeout(() => {
          // console.log($(obj).attr("id"));
          $(obj).datepicker().datepicker('setDate', new Date($(obj).val()));
        }, 100);
        $('#ui-datepicker-div').addClass('dataTimePicker wbmodal-datepicker');
      },
      onSelect(date) {
        callback($(this), date);
        setTimeout(() => {
          $('#workloadStartText').datepicker().datepicker('option', 'maxDate', new Date($('#workloadDueText').val()));
          $('#workloadDueText').datepicker().datepicker('option', 'minDate', new Date($('#workloadStartText').val()));
        }, 100);
      },
    });
    $(obj).datepicker().datepicker('setDate', new Date(current_date));
    $(obj).datepicker().datepicker('option', maxOrMin, new Date(maxMinDate));
  }

  initializeDueDate() {
    const workloadDetails = this.props.workload.workloadDetails || {};
    this.initDatePicker($('#workloadDueText'), this.saveEndDate, workloadDetails.endDate, 'minDate', workloadDetails.startDate);
  }

  initializeStartDate() {
    const workloadDetails = this.props.workload.workloadDetails || {};
    this.initDatePicker($('#workloadStartText'), this.saveStartDate, workloadDetails.startDate, 'maxDate', workloadDetails.endDate);
  }

  startDateClick() {
    $('#workloadStartText').datepicker('show');
  }

  dueDateClick() {
    $('#workloadDueText').datepicker('show');
  }

  saveStartDate(obj, date) {
    const _this = this;
    const workloadDetails = this.props.workload.workloadDetails || {};
    // check if start date is greater than end date
    const endDt = '';
    const dataStr = $(obj).attr('value');
    const dateStartEnd = (dataStr != '' && dataStr != 'No Date') ? new Date(dataStr) : 0;
    const dateDueEnd = (endDt != '' && endDt != 'No Date') ? new Date(endDt) : 0;
    let startTimeStamp = 0;
    if (date == '') {
      var updatedDStrYear = 'No Date';
      date = 'No Date';
      startTimeStamp = 0;
    } else {
      var updatedDStrYear = moment(date, 'MMM DD, YYYY').format('MMM DD, YYYY');
      startTimeStamp = new Date(date).getTime() / 1000;
    }
    // console.log(date);
    this.loadFullComponent(date, workloadDetails.endDate);
  }

  saveEndDate(obj, date) {
    const _this = this;
    const workloadDetails = this.props.workload.workloadDetails || {};
    // let aiId = ai.id;
    // check if end date is less than start date
    const stDt = '';
    const dataStr = $(obj).attr('value');
    const dateDueEnd = (dataStr != '' && dataStr != 'No Date') ? new Date(dataStr) : 0;
    const dateDueStart = (stDt != '' && stDt != 'No Date') ? new Date(stDt) : 0;
    let overdue = 'remove';
    let dueDateVal = 0;
    if (date == '') {
      var updatedDStrYear = 'No Date';
      date = 'No Date';
    } else {
      var updatedDStrYear = moment(date, 'MMM DD, YYYY').format('MMM DD, YYYY');
      dueDateVal = new Date(date).getTime() / 1000;
      const now = new Date((new Date()).setHours(0, 0, 0, 0)).getTime() / 1000;
      if (typeof dueDateVal !== 'undefined' && dueDateVal != '' && dueDateVal != 0 && dueDateVal < now) {
        overdue = 'add';
      }
    }
    let dueRed = '';
    if (overdue == 'add') {
      dueRed = '1d';
    }
    // console.log(date);
    this.loadFullComponent(workloadDetails.startDate, date);
  }

  loadFullComponent(start, end) {
    const { actions } = this.props;
    showLoaderWidget($('#content'));
    $.get(`${wbConfig.baseUrl}/workload/updateDate`, { start_date: start, end_date: end }, (data, status) => {
      removeLoaderWidget();
      if (data.data) {
        // workloadBandwidthPageLoadComponent(data.data);
        actions.WorkLoadFullLoad(data.data);
      }
    });
  }

  triggerLoadFullComponent() {
    const { workloadDetails } = this.props.workload;
    this.loadFullComponent(workloadDetails.startDate, workloadDetails.endDate);
  }

  satusFilterClick(event, status) {
    const { actions } = this.props;
    const { checked } = event.target;
    const { value } = event.target;
    actions.WorkloadStatusFilter(checked, status, value);
    this.saveFilterOption('status');
  }

  saveFilterOption(source) {
    const data = {};
    const workloadDetails = this.props.workload.workloadDetails || {};
    if (source == 'status') {
      data.status = workloadDetails.status;
    } else if (source == 'priority') {
      data.priority = workloadDetails.priority;
    }
    $.post(`${wbConfig.baseUrl}/workload/saveFilter`, { source, data }, (data, status) => {

    });
  }

  priorityFilterClick(event, status) {
    const { actions } = this.props;
    const { checked } = event.target;
    const { value } = event.target;
    actions.WorkloadPriorityFilter(checked, status, value);
    this.saveFilterOption('priority');
  }

  member_capacity() {
    this.setState({
      showMemberCapacityPopup: !this.state.showMemberCapacityPopup,
    });
  }

  render() {
    const workloadDetails 	= this.props.workload.workloadDetails || {};
    // console.log(workloadDetails);
    const doingStatus = workloadDetails.status.doing || false;
    const nextStatus = workloadDetails.status.next || false;
    const pauseStatus = workloadDetails.status.pause || false;
    const doneStatus = workloadDetails.status.done || false;
    const lowPriority = workloadDetails.priority.low || false;
    const mediumPriority = workloadDetails.priority.medium || false;
    const highPriority = workloadDetails.priority.high || false;
    const { showMemberCapacityPopup } = this.state;

    return (
      <div className="WorkloadFiltersCompHeading">
        {showMemberCapacityPopup &&
          <MemberCapacity {...this.props} onClose={() => this.member_capacity()} />
        }
        <div className="WorkloadFiltersCompRow">
          <div className="triggerLoadFullComponent hide" onClick={() => this.triggerLoadFullComponent()} />
          <div className="WorkloadFiltersCompColumn filterPeriod italicFont">
                        For Period:
          </div>
          <div className="WorkloadFiltersCompColumn startDateColumn filterClickable" onClick={() => this.startDateClick()}>
            {workloadDetails.startDate}
            <input type="text" className="dueDateDiv" name="start_date" id="workloadStartText" defaultValue={workloadDetails.startDate} />
          </div>
          <div className="WorkloadFiltersCompColumn betweenString">
                        to
          </div>
          <div className="WorkloadFiltersCompColumn endDateColumn filterClickable" onClick={() => this.dueDateClick()}>
            {workloadDetails.endDate}
            <input type="text" className="dueDateDiv" name="due_date" id="workloadDueText" defaultValue={workloadDetails.endDate} />
          </div>
          <div className="WorkloadFiltersCompColumn weeksColumn">
            {workloadDetails.totalWeeks}
          </div>
          <div className="WorkloadFiltersCompColumn totalColumn filterClickable" id="memberPopup" onClick={e => this.member_capacity()}>
            <img className="imagePosition" src={`${wbConfig.imageCdnUrl}/images/icons/workload_bandwidth.png`} />
            {' '}
Total Load
          </div>
          <div className="WorkloadFiltersCompColumn statusColumn">
            <div className="italicFont displayInline">
                            Status:
            </div>
            <div className="displayInline">
              <div className="state displayTableRow">
                <div className="doing1 statusColumnWidth displayTableCell">
                  <input type="checkbox" className="css-checkbox" checked={doingStatus} value="1" name="state[]" id="doing-checkbox" onClick={e => this.satusFilterClick(e, 'doing')} />
                  <label className="css-label modalParaText" htmlFor="doing-checkbox">
                    <img width="15px" className="imagePosition" src={`${wbConfig.imageCdnUrl}/images/icons/edit_images/doing.png`} />
                  </label>
                </div>
                <div className="pause1 statusColumnWidth displayTableCell">
                  <input type="checkbox" className="css-checkbox" checked={pauseStatus} value="4" name="state[]" id="pause-checkbox" onClick={e => this.satusFilterClick(e, 'pause')} />
                  <label className="css-label modalParaText" htmlFor="pause-checkbox">
                    <img width="15px" className="imagePosition" src={`${wbConfig.imageCdnUrl}/images/icons/edit_images/pause_grey.png`} />
                  </label>
                </div>
                <div className="next1 statusColumnWidth displayTableCell">
                  <input type="checkbox" className="css-checkbox" checked={nextStatus} value="2" name="state[]" id="next-checkbox" onClick={e => this.satusFilterClick(e, 'next')} />
                  <label className="css-label modalParaText" htmlFor="next-checkbox">
                    <img width="15px" className="imagePosition" src={`${wbConfig.imageCdnUrl}/images/icons/edit_images/next.png`} />
                  </label>
                </div>
                <div className="done1 statusColumnWidth displayTableCell">
                  <input type="checkbox" className="css-checkbox" checked={doneStatus} value="0" name="state[]" id="done-checkbox" onClick={e => this.satusFilterClick(e, 'done')} />
                  <label className="css-label modalParaText" htmlFor="done-checkbox">
                    <img width="15px" className="imagePosition" src={`${wbConfig.imageCdnUrl}/images/icons/widget/green_done.png`} />
                  </label>
                </div>

              </div>
            </div>
          </div>
          <div className="WorkloadFiltersCompColumn priorityColumn">
            <div className="italicFont displayInline">
                            Priority:
            </div>
            <div className="displayInline">
              <div className="priority displayTableRow">
                <div className="high statusColumnWidth displayTableCell">
                  <input type="checkbox" className="css-checkbox" checked={highPriority} value="1" name="priority[]" id="high-checkbox" onClick={e => this.priorityFilterClick(e, 'high')} />
                  <label className="css-label modalParaText" htmlFor="high-checkbox">
                    <img width="15px" className="imagePosition" src={`${wbConfig.imageCdnUrl}/images/icons/high@3x.png`} />
                  </label>
                </div>
                <div className="medium statusColumnWidth displayTableCell">
                  <input type="checkbox" className="css-checkbox" checked={mediumPriority} value="2" name="priority[]" id="medium-checkbox" onClick={e => this.priorityFilterClick(e, 'medium')} />
                  <label className="css-label modalParaText" htmlFor="medium-checkbox">
                    <img width="15px" className="imagePosition" src={`${wbConfig.imageCdnUrl}/images/icons/medium@3x.png`} />
                  </label>
                </div>
                <div className="low statusColumnWidth displayTableCell">
                  <input type="checkbox" className="css-checkbox" checked={lowPriority} value="3" name="priority[]" id="low-checkbox" onClick={e => this.priorityFilterClick(e, 'low')} />
                  <label className="css-label modalParaText" htmlFor="low-checkbox">
                    <img width="15px" className="imagePosition" src={`${wbConfig.imageCdnUrl}/images/icons/low@3x.png`} />
                  </label>
                </div>
              </div>
            </div>
          </div>
          {<WorkLoadFilterTextCompHOC {...this.props} /> }


        </div>
      </div>
    );
  }
}

const WorkLoadAIItemsComp = ({ items, handlers, tagId }) => {
  const tasks = items; let
    divContent;
  if (items.overlapping_items.length) {
    let i = 0;
    divContent = items.overlapping_items.map((item) => {
      i += 1;
      return <WorkLoadAIItemComp item={item} handlers={handlers} length={items.overlapping_items.length} i={i} />;
    });
  } else {
    divContent = <WorkLoadAIItemComp item={items} handlers={handlers} length={1} i={1} />;
  }
  const aiOwnerName = `${items.firstname} ${items.lastname}`;
  return (
    <div className="gantt-overlapping-items-wrapper">
      <div className="workloadAiOwner truncateText">{aiOwnerName}</div>
      {divContent}
    </div>
  );
};
const WorkLoadAIItemComp = ({
  item, handlers, length, i,
}) => {
  const width290 = length <= 4 ? 'width290' : '';
  const borderNone = (i == length) ? 'borderNone' : '';
  // console.log(i);
  return (
    <div className="displayTable gantt-overlapping-item" data-id={item.id} data-wsid={item.id} onClick={() => handlers(item)}>
      <div className="displayTableRow">
        <div className="displayTableCell">
          <div className="workloadPrioImg" data-value={item.priority} />
        </div>
        <div className="displayTableCell">
          <div className={` aiName truncateText ${width290}`}>
            {item.name}
          </div>
        </div>
        <div className="displayTableCell ">
          <div className="workloadStatusImg" data-value={item.state} />
        </div>

      </div>
      <div className="displayTableRow">
        <div className="displayTableCell" />
        <div className={`displayTableCell teamNameHead ${borderNone}`}>
          <div className={`teamName truncateText widthH ${width290}`} title={`${item.team_name}: ${item.tag_name}`}>
            {item.team_name}
:
            {item.tag_name}
          </div>
        </div>
        <div className={`displayTableCell dateDe ${borderNone}`}>
          {item.start_text}
          {' '}
-
          {item.end_text}
        </div>
      </div>
    </div>
  );
};
/* Filter Comp */
class WorkLoadFilterTextComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_people: false,
      filter_objectives: false,
      filter_workstreams: false,
    };
    this.filter_people = this.filter_people.bind(this);
    this.filter_objectives = this.filter_objectives.bind(this);
    this.filter_ws = this.filter_ws.bind(this);
    this.handleFilterClick = this.handleFilterClick.bind(this);
    this.saveFilterOption = this.saveFilterOption.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.handleFilterClick, true);
  }

  filter_people(val = true) {
    this.setState({
      filter_people: val,
    });
  }

  filter_objectives(val = true) {
    this.setState({
      filter_objectives: val,
    });
  }

  filter_ws(val = true) {
    this.setState({
      filter_ws: val,
    });
  }

  handleFilterClick(e) {
    if (!$('.filterByPopup').is(e.target) // if the target of the click isn't the container...
            && $('.filterByPopup').has(e.target).length === 0) {
      this.setState({
        filter_people: false,
        filter_objectives: false,
        filter_ws: false,
      });
    }
  }

  saveFilterOption(source) {
    const data = {};
    const workloadDetails = this.props.workload.workloadDetails || {};
    if (source == 'filter_people') {
      this.filter_people(false);
      data.filter_people = workloadDetails.filter_people.selUser;
      this.props.workload.workloadDetails.filter_sele_all.people = false;
    } else if (source == 'filter_ws') {
      this.filter_ws(false);
      data.filter_ws = workloadDetails.filter_ws;
      this.props.workload.workloadDetails.filter_sele_all.ws = false;
    } else if (source == 'filter_objective') {
      this.filter_objectives(false);
      data.filter_objective = workloadDetails.filter_objective;
      this.props.workload.workloadDetails.filter_sele_all.objective = false;
    }
    // console.log(data);
    $.post(`${wbConfig.baseUrl}/workload/saveFilter`, { source, data }, (data, status) => {

    });
  }

  render() {
    const { t } = this.props;
    const workloadDetails = this.props.workload.workloadDetails || {};
    return (
      <div className="WorkloadFiltersCompColumn filterByColumn">
        <div className="italicFont displayInline">
                        Filter by:
        </div>
        <div className="displayInline">
          <div className="filter displayTableRow">
            <div className="filterColumnWidth displayTableCell filterClickable" onClick={e => this.filter_people()}>
                                People
            </div>
            {
              <div className="filterColumnWidth displayTableCell  filterClickable" onClick={e => this.filter_objectives()}>
                                   {t('Objectives')}
              </div>
                            }
            <div className="filterColumnWidth displayTableCell filterClickable" onClick={e => this.filter_ws()}>
                               Workstreams
            </div>
          </div>
        </div>
        {this.state.filter_people == true && <Filter_people workloadDetails={workloadDetails} actions={this.props.actions} allProps={this} />}
        {this.state.filter_objectives == true && <Filter_objectives workloadDetails={workloadDetails} actions={this.props.actions} allProps={this} t={t} />}
        {this.state.filter_ws == true && <Filter_ws workloadDetails={workloadDetails} actions={this.props.actions} allProps={this} />}
      </div>
    );
  }
}
const WorkLoadFilterTextCompHOC = withTranslation()(WorkLoadFilterTextComp);

/* Filter by workstreams poup */
class Filter_ws extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: this.props.workloadDetails.wsContent || [],
      workloadDetails: this.props.workloadDetails,
      checkAll: false,
      defaultSelectAll: this.props.workloadDetails.filter_sele_all.ws || false,
    };
    this.checkBoxSelection = this.checkBoxSelection.bind(this);
    this.loadWsList = this.loadWsList.bind(this);
    this.onClcikCheckAll = this.onClcikCheckAll.bind(this);
    this.ClcikCheckBox = this.ClcikCheckBox.bind(this);
    this.WsClickCheckbox = this.WsClickCheckbox.bind(this);
    this.showWsFilter = this.showWsFilter.bind(this);
  }

  componentDidMount() {
    this.loadWsList();
  }

  checkBoxSelection(contentdata) {
    const selectdWs = this.state.workloadDetails.filter_ws || [];
    let count_goal = 0;
    let selWs = 0;
    let checkAll = false;
    contentdata = contentdata.map((item) => {
      let count_ws = 0;
      item.wsLis = item.wsLis.map((items) => {
        const findWs = selectdWs.find(ws => items.wsId == ws);
        if (findWs) {
          items.checked = true;
          selWs += 1;
          count_ws += 1;
        } else {
          items.checked = false;
        }
        count_goal += 1;
        return items;
      });
      if (count_ws == item.wsLis.length) {
        item.checked = true;
      } else {
        item.checked = false;
      }
      return item;
    });
    if (count_goal == selWs) {
      checkAll = true;
    }
    this.setState({
      content: contentdata,
      checkAll,
    });
    this.props.workloadDetails.wsContent = contentdata;
    if (this.state.defaultSelectAll && count_goal != selWs) {
      this.setState({
        checkAll: false,
      });
      this.onClcikCheckAll();
    }
  }

  loadWsList() {
    const _this = this;
    if (_this.state.content.length === 0) {
      $.get(`${wbConfig.baseUrl}/workload/getTeamManageWsList`, (data, status) => {
        if (data.wsList.length) {
          _this.checkBoxSelection(data.wsList);
        }
      });
    } else {
      this.checkBoxSelection(_this.state.content);
    }
  }

  onClcikCheckAll() {
    const checkAll = this.state.checkAll != true;
    const contentdata = this.state.content.map((item) => {
      item.checked = checkAll;
      item.wsLis = item.wsLis.map((items) => {
        items.checked = checkAll;
        return items;
      });
      return item;
    });
    this.setState({
      checkAll,
      content: contentdata,
    });
  }

  ClcikCheckBox(event) {
    const this_ = this;
    const currentChecked = event.target.checked;
    const currentValue = event.target.value;
    const contentdata = this.state.content.map((item) => {
      if (item.teamId == currentValue) {
        item.checked = currentChecked;
      }
      item.wsLis = item.wsLis.map((items) => {
        if (item.teamId == currentValue) {
          items.checked = currentChecked;
        }
        return items;
      });

      return item;
    });
    this_.setState({
      content: contentdata,
      checkAll: false,
    });
  }

  WsClickCheckbox(event) {
    const this_ = this;
    const currentChecked = event.target.checked;
    const currentValue = event.target.value;
    const contentdata = this.state.content.map((item) => {
      let childCond = 0;
      item.wsLis = item.wsLis.map((items) => {
        if (items.wsId == currentValue) {
          items.checked = currentChecked;
          childCond = 1;
        }
        return items;
      });
      if (childCond == 1) {
        item.checked = false;
      }
      return item;
    });
    this_.setState({
      content: contentdata,
      checkAll: false,
    });
  }

  showWsFilter() {
    const { actions } = this.props;
    const selWs = $('.wsSelects:checked').map(function () {
      return this.value;
    }).get();
    actions.WorkloadWsFilter(selWs);
    this.props.allProps.saveFilterOption('filter_ws');
  }

  render() {
    const wsList = this.state.content || [];
    const checkAll = this.state.checkAll || false;
    return (
      <div className="filterByPopup ">
        <div className="filterPopupHead ">Filter by specific workstreams:</div>
        <div className="filterPopupContentWrap">
          <div className="filterPopupContent filterPopupContentScroll">
            <input type="checkBox" className="css-checkbox selectAllchkbox" id="wsSelectAll" onClick={e => this.onClcikCheckAll()} checked={checkAll} />
            <label className="css-label" htmlFor="wsSelectAll">
              <div className="selectAllText">Select All</div>
            </label>
            <div className="displyData">
              {
                                wsList.map(item => (
                                  <div className="dataRow">
                                    <div className="rowItem">
                                      <div className="rowItemChkbox">
                                        <input type="checkBox" className="css-checkbox" id={item.teamId} value={item.teamId} checked={item.checked} onClick={e => this.ClcikCheckBox(e)} />
                                        <label className="css-label rowItemName truncateText" htmlFor={item.teamId} />

                                      </div>
                                      <div className="rowItemName">
                                        {item.teamName}
                                      </div>
                                    </div>
                                    { item.wsLis.map((items, index) => (

                                      <div className="rowSubItems">
                                        <div className="subItem">
                                          <div className="subItemChkbox">
                                            <input type="checkBox" className="css-checkbox wsSelects" id={item.teamId + items.wsId} checked={items.checked} value={items.wsId} teamId={item.teamId} onClick={e => this.WsClickCheckbox(e)} />
                                            <label className="css-label subItemName truncateText" htmlFor={item.teamId + items.wsId} />
                                          </div>
                                          <div className="subItemName">
                                            {items.wsName}
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                            }
                                  </div>
                                ))
                            }
            </div>
          </div>

        </div>
        <div className="filterPopupButton">
          <input type="button" value="Show" name="Show" id="" className="fltr_btn_save" onClick={e => this.showWsFilter()} />
        </div>
      </div>
    );
  }
}
/* Filter by workstreams End poup */


/* Filter by objectives poup */
class Filter_objectives extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: this.props.workloadDetails.objectivesContent || [],
      workloadDetails: this.props.workloadDetails,
      defaultSelectAll: this.props.workloadDetails.filter_sele_all.objective || false,
      checkAll: false,
      noResult: false,
    };
    this.checkBoxSelection = this.checkBoxSelection.bind(this);
    this.loadObjectiveList = this.loadObjectiveList.bind(this);
    this.onClcikCheckAll = this.onClcikCheckAll.bind(this);
    this.WsClickCheckbox = this.WsClickCheckbox.bind(this);
    this.showObjectiveFilter = this.showObjectiveFilter.bind(this);
  }

  componentDidMount() {
    this.loadObjectiveList();
  }

  checkBoxSelection(contentdata) {
    let count_goal = 0;
    let selWs = 0;
    let checkAll = false;
    const selectdWs = this.state.workloadDetails.filter_objective || [];
    if (contentdata) {
      contentdata = contentdata.map((item) => {
        let count_ws = 0;
        item.wsLis = item.wsLis.map((items) => {
          const findWs = selectdWs.find(ws => items.wsId == ws);
          if (findWs) {
            items.checked = true;
            selWs += 1;
            count_ws += 1;
          } else {
            items.checked = false;
          }
          count_goal += 1;
          return items;
        });
        if (count_ws == item.wsLis.length) {
          item.checked = true;
        } else {
          item.checked = false;
        }
        return item;
      });
    }
    // console.log(count_goal);
    if (count_goal == selWs) {
      checkAll = true;
    }
    this.setState({
      content: contentdata,
      checkAll,
    });
    this.props.workloadDetails.objectivesContent = contentdata;
    // console.log(this.state.defaultSelectAll);
    if (this.state.defaultSelectAll && count_goal != selWs) {
      this.setState({
        checkAll: false,
      });
      this.onClcikCheckAll();
    }
  }

  loadObjectiveList() {
    const _this = this;
    if (_this.state.content.length == 0) {
      $.get(`${wbConfig.baseUrl}/workload/GetTeamManageWsListFromGoal`, (data, status) => {
        if (data.wsList.length) {
          _this.checkBoxSelection(data.wsList);
          _this.setState({
            noResult: false,
          });
        } else {
          _this.setState({
            noResult: true,
          });
        }
      });
    } else {
      this.checkBoxSelection(_this.state.content);
    }
  }

  onClcikCheckAll() {
    const checkAll = this.state.checkAll != true;
    const contentdata = this.state.content.map((item) => {
      item.checked = checkAll;
      item.wsLis = item.wsLis.map((items) => {
        items.checked = checkAll;
        return items;
      });
      return item;
    });
    this.setState({
      checkAll,
      content: contentdata,
    });
  }

  ClcikCheckBox(event) {
    const this_ = this;
    const currentChecked = event.target.checked;
    const currentValue = event.target.value;
    const contentdata = this.state.content.map((item) => {
      if (item.goal_id == currentValue) {
        item.checked = currentChecked;
      }
      item.wsLis = item.wsLis.map((items) => {
        if (item.goal_id == currentValue) {
          items.checked = currentChecked;
        }
        return items;
      });

      return item;
    });
    this_.setState({
      content: contentdata,
      checkAll: false,
    });
  }

  WsClickCheckbox(event) {
    const this_ = this;
    const currentChecked = event.target.checked;
    const currentValue = event.target.value;
    const contentdata = this.state.content.map((item) => {
      let childCond = 0;
      item.wsLis = item.wsLis.map((items) => {
        if (items.wsId == currentValue) {
          items.checked = currentChecked;
          childCond = 1;
        }
        return items;
      });
      if (childCond == 1) {
        item.checked = false;
      }
      return item;
    });
    this_.setState({
      content: contentdata,
      checkAll: false,
    });
  }

  showObjectiveFilter() {
    const { actions } = this.props;
    const selObjective = $('.ObjectiveSelects:checked').map(function () {
      return this.value;
    }).get();

    actions.WorkloadObjectiveFilter(selObjective);
    // console.log(selObjective);
    this.props.allProps.saveFilterOption('filter_objective');
  }

  render() {
    const { t } = this.props;
    const objective = this.state.content;
    const { checkAll } = this.state;
    // console.log(objective);
    return (
      <div className="filterByPopup ">
        <div className="filterPopupHead ">Filter by work aligned to {t('objectives')}:</div>
        <div className="filterPopupContentWrap">
          <div className="filterPopupContent filterPopupContentScroll">
            <input type="checkBox" className="css-checkbox selectAllchkbox" id="objectiveSelectAll" onClick={e => this.onClcikCheckAll()} checked={checkAll} />
            { !this.state.noResult && (
            <label className="css-label" htmlFor="objectiveSelectAll">
              <div className="selectAllText">Select All</div>
            </label>
            )
                                }
            <div className="displyData">
              {
                                    objective.map(item => (
                                      <div className="dataRow">
                                        <div className="rowItem">
                                          <div className="rowItemChkbox">
                                            <input type="checkbox" className="css-checkbox" id={item.goal_id} value={item.goal_id} checked={item.checked} onClick={e => this.ClcikCheckBox(e)} />
                                            <label className="css-label rowItemName truncateText" htmlFor={item.goal_id} />

                                          </div>
                                          <div className="rowItemName">
                                            {item.goal_name}
                                          </div>
                                        </div>
                                        { item.wsLis.map((items, index) => (

                                          <div className="rowSubItems">
                                            <div className="subItem">
                                              <div className="subItemChkbox">
                                                <input type="checkbox" className="css-checkbox ObjectiveSelects" id={item.goal_id + items.wsId} checked={items.checked} value={items.wsId} teamId={item.goal_id} onClick={e => this.WsClickCheckbox(e)} />
                                                <label className="css-label subItemName truncateText" htmlFor={item.goal_id + items.wsId} />
                                              </div>
                                              <div className="subItemName">
                                                {items.wsName}
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                                }
                                      </div>
                                    ))
                                }
              {
                                        this.state.noResult && <div>No Result Found</div>
                                }
            </div>
          </div>

        </div>
        <div className="filterPopupButton">
          <input type="button" value="Show" name="Show" id="" className="fltr_btn_save" onClick={e => this.showObjectiveFilter()} />
        </div>
      </div>

    );
  }
}
/* Filter by objectives End poup */


/* Filter by People poup */
class Filter_people extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      workloadDetails: this.props.workloadDetails,
      content: this.props.workloadDetails.peopleContent || [],
      searchText: '',
      initialItems: [],
      searchData: {},
      checkAll: false,
      defaultSelectAll: this.props.workloadDetails.filter_sele_all.people || false,
    };
    this.checkBoxSelection = this.checkBoxSelection.bind(this);
    this.loadUserLis = this.loadUserLis.bind(this);
    this.ClcikCheckBox = this.ClcikCheckBox.bind(this);
    this.onClcikCheckAll = this.onClcikCheckAll.bind(this);
    this.searchText = this.searchText.bind(this);
    this.filteredData = this.filteredData.bind(this);
    this.showPeopleFilter = this.showPeopleFilter.bind(this);
  }

  componentDidMount() {
    this.loadUserLis();
  }

  checkBoxSelection(contentdata) {
    const selectdPeoples = this.state.workloadDetails.filter_people.selUser;
    const count_user = contentdata.length;
    let selUlist = 0;
    let checkAll = false;
    contentdata = contentdata.map((item) => {
      if ($.inArray(item.user_id, selectdPeoples) > -1) {
        item.checked = true;
        selUlist += 1;
      } else {
        item.checked = false;
      }
      return item;
    });
    if (count_user == selUlist) {
      checkAll = true;
    }
    this.setState({
      content: contentdata,
      initialItems: contentdata,
      checkAll,
    });
    this.props.workloadDetails.peopleContent = contentdata;
    if (this.state.defaultSelectAll && count_user != selUlist) {
      this.setState({
        checkAll: false,
      });
      this.onClcikCheckAll();
    }
  }

  loadUserLis() {
    const _this = this;
    if (_this.state.content.length == 0) {
      $.get(`${wbConfig.baseUrl}/workload/getUserList`, (data, status) => {
        if (data.useList.length) {
          _this.checkBoxSelection(data.useList);
        }
      });
    } else {
      _this.checkBoxSelection(_this.state.content);
    }
  }

  ClcikCheckBox(user_id) {
    const contentdata = this.state.content.map((item) => {
      if (item.user_id == user_id) {
        item.checked = (item.checked != true);
      }
      return item;
    });
    this.setState({
      content: contentdata,

    });
    let selUlist = 0;
    const count_user = this.state.content.length;
    let checkAll = false;
    this.state.content.map((item) => {
      if (item.checked == true) {
        selUlist += 1;
      }
    });
    if (count_user == selUlist) {
      checkAll = true;
    }
    this.setState({
      checkAll,
    });
  }

  onClcikCheckAll() {
    const checkAll = this.state.checkAll != true;
    // console.log(checkAll);
    const contentdata = this.state.content.map((item) => {
      item.checked = checkAll;
      return item;
    });
    this.setState({
      checkAll,
      content: contentdata,
    });
    // console.log(contentdata);
  }

  searchText(e) {
    this.state.searchText = e.target.value;
    const filteredDataList = this.state.initialItems.filter(this.filteredData);
    this.setState({
      content: filteredDataList,
    });
  }

  filteredData(item) {
    const { searchText } = this.state;
    if (searchText != '') {
      const itemTitle = '';
      const searchTextLowerCase = searchText.toLowerCase();
      const itemFirstName = item.name.toLowerCase();
      return itemFirstName.indexOf(searchTextLowerCase) !== -1;
    }

    return true;
  }

  showPeopleFilter() {
    const { actions } = this.props;
    const selUser = $('.pplSelect:checkbox:checked').map(function () {
      return this.value;
    }).get();
    actions.WorkloadUserFilter(selUser);
    // console.log(this.props.allProps);
    this.props.allProps.saveFilterOption('filter_people');
  }

  render() {
    const placeholder = 'Search for a person';
    const tasks = this.state.content || [];
    const { checkAll } = this.state;
    // console.log(tasks);
    return (
      <div className="filterByPopup">
        <div className="">
          <div className="filterPopupHead">Filter by people's workload</div>
          <div className="filterPopupContentWrap ">
            <div className="filterPopupContent">
              <input className="gbl-text-entry text-field pplInput" placeholder={placeholder} onChange={this.searchText} />
              <div className="pplNameWrap">
                <div className="filterPopupSelectAll pplSelectAllWrp">
                  <input type="checkBox" className="css-checkbox selectAllchkbox pplSelectAll" id="pplSelectAll" onClick={e => this.onClcikCheckAll()} checked={checkAll} />
                  <label className="css-label selectAllText" htmlFor="pplSelectAll"> Select All </label>

                </div>
                <div className="pplRwoShow">
                  {
                                        tasks.map(item => (
                                          <div className="rowItem">
                                            <div className="rowItemChkbox">
                                              <input type="checkBox" className="css-checkbox pplSelect" id={item.user_id} user-id={item.user_id} value={item.user_id} checked={item.checked} onClick={e => this.ClcikCheckBox(item.user_id)} />
                                              <label className="css-label rowItemName truncateText" htmlFor={item.user_id} />
                                            </div>
                                            <div className="rowItemName truncateText" user-id={item.user_id}>
                                              {item.name}
                                            </div>
                                          </div>
                                        ))
                                    }
                </div>
              </div>
            </div>
            <div className="filterPopupButton">
              <input type="button" value="Show" name="Show" id="pplShowClcik" className="fltr_btn_save" onClick={e => this.showPeopleFilter()} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
/* Filter by People poup End */
